import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { actionTypes, attachmentStatuses, alfrescoTypes } from '../../constants';
import i18next from "../../i18n";
import { CommentForm } from '../comments/CommentForm';
import { downloadFile } from '../document/DocumentHelpers';
import { dispatcherActionTypes, globalEventDispatcher } from '../helpers/GlobalEventDispatcher';
import { getBase64 } from '../helpers/HelperFunctions';
import { hideModalDialog, showModalDialog } from '../ModalDialog';
import { Svg } from '../Svg';
import { Table, getEnumsTitle } from '../table/Table';
import { TableFilterBlock } from '../table/TableFilterBlock';
import { AttachmentForm } from './AttachmentForm';
import { PdfViewer } from '../PdfViewer';
import { TableColumnType } from '../table/Table';
import { isImageFile } from '../helpers/CheckFunctions';

const settings = {
    "attachmentsTable": {
        "name": "attachmentsTable",
        "columns": [
            {
                "name": "Id",
                "headerName": "",
                "type": TableColumnType.String,
                "hidden": true
            },
            {
                "name": "NodeRef",
                "headerName": "",
                "type": TableColumnType.String,
                "hidden": true
            },
            {
                "name": "Title",
                "CanSort": true,
                "headerName": i18next.t("documentName"),
                "type": TableColumnType.String
            },
            {
                "name": "DocumentType",
                "CanSort": true,
                "headerName": i18next.t("documentType"),
                "type": TableColumnType.String,
                "enums": [],
                "filtersValues": []
            },
            {
                "name": "Number",
                "headerName": i18next.t("number"),
                "type": TableColumnType.String
            },
            {
                "name": "DocumentDate",
                "headerName": i18next.t("date"),
                "type": TableColumnType.String
            },
            {
                "name": "State",
                "headerName": i18next.t("status"),
                "type": TableColumnType.Status,
                "enums": []
            },
            {
                "name": "Comment",
                "headerName": i18next.t("comment"),
                "type": TableColumnType.Comment
            },
            {
                "name": "CreatorFullName",
                "headerName": i18next.t("author"),
                "type": TableColumnType.String
            },
            {
                "name": "Created",
                "headerName": i18next.t("dateAddition"),
                "type": TableColumnType.String
            },
            {
                "name": "Indicator",
                "headerName": "",
                "type": TableColumnType.Default
            }
        ],
        actions: [
            {
                "title": i18next.t("add"),
                "btnClass": "",
                "type": actionTypes.add
            },
            {
                "title": i18next.t("noDocument"),
                "btnClass": "btn-secondary",
                "type": actionTypes.notAdd,
                "isMultiaction": true
            },
            {
                "title": i18next.t("sign"),
                "btnClass": "",
                "type": actionTypes.sign,
                "isMultiaction": true
            },
            {
                "title": i18next.t("view"),
                "btnClass": "btn-primary",
                "type": actionTypes.preview
            },
            {
                "title": i18next.t("edit"),
                "btnClass": "btn-secondary",
                "type": actionTypes.edit
            },
            {
                "title": i18next.t("download"),
                "btnClass": "btn-secondary",
                "type": actionTypes.download,
                "isMultiaction": true
            },
            {
                "title": i18next.t("downloadWithSignatures"),
                "btnClass": "btn-secondary",
                "type": actionTypes.loadSigns,
                "isMultiaction": true
            },
            {
                "title": i18next.t("remove"),
                "btnClass": "btn-no-fill",
                "type": actionTypes.remove,
                "isMultiaction": true
            }
        ]
    }
}
for (let i = 0; i < settings.attachmentsTable.actions.length; ++i)
    settings.attachmentsTable.actions[i].sortIndex = i;
for (let i = 0; i < settings.attachmentsTable.columns.length; ++i)
    settings.attachmentsTable.columns[i].id = i.toString();
export class AttachmentsForm extends Component {
    static propTypes = {
        attachments: PropTypes.array,
        typesOfDocumens: PropTypes.array.isRequired,
        handleAddAttachment: PropTypes.func,
        getAttachmentIndicatorHandler: PropTypes.func,
        edite: PropTypes.bool,
        handleRemoveAttachmentFile: PropTypes.func
    };
    constructor(props) {
        super(props);
        const { attachments, typesOfDocumens } = this.props;
        this.state = {
            attachments: attachments,
            typesOfDocumens: typesOfDocumens,
            statuses: [],
            filtersValues: {},
            rows: [],
            type: alfrescoTypes.additionalDocument,
            columns: JSON.parse(JSON.stringify(settings.attachmentsTable.columns))
        };
        this.handleAddAttachment = this.handleAddAttachment.bind(this);
        this.actionHandlerCallback = this.actionHandlerCallback.bind(this);
        this.deleteAttachments = this.deleteAttachments.bind(this);
        this.loadFilePreview = this.loadFilePreview.bind(this);
        this.downloadFiles = this.downloadFiles.bind(this);
        this.onColumnFilter = this.onColumnFilter.bind(this);
        this.handlerCheckRowVisibility = this.handlerCheckRowVisibility.bind(this);
        this.onSearchClear = this.onSearchClear.bind(this);
    }
    componentDidMount() {
        require(`../Dictionary`).getAdditionalDocumentsStates().then(data => { this.setState({ statuses: data }); });
    }
    componentDidUpdate() {
        if (this.props.attachments !== this.state.attachments || this.props.typesOfDocumens !== this.state.typesOfDocumens) {
            this.setState({ attachments: this.props.attachments, typesOfDocumens: this.props.typesOfDocumens });
        }
    }
    deleteAttachments(ids) {
        let { attachments } = this.state;
        attachments = attachments.filter(a => !ids.includes(a.id));
        this.setState({ attachments: attachments });
        globalEventDispatcher.dispatch(dispatcherActionTypes.onUnselectTableAllRows);
        if (this.props.changedCallback)
            this.props.changedCallback(attachments);
    }
    handleAddAttachment(document) {
        hideModalDialog('modalDialog');
        let attachments = this.state.attachments;
        document.state = attachmentStatuses.New;
        if (document.id) {
            let index = attachments.findIndex(a => a.id === document.id);
            if (index >= 0) {
                let curType = this.state.typesOfDocumens.find((item) => {
                    return item.value === document.documentType;
                });
                if (document.file) {
                    document.title = curType.title;
                    let fileNameParts = document.file.name.split('.');
                    if (fileNameParts.length > 0) {
                        let extension = fileNameParts[fileNameParts.length - 1].toLowerCase();
                        document.title += '.' + extension;
                        let docIndex = 2;
                        while (attachments.find(a => a.title === document.title)) {
                            document.title = `${curType.title} (${docIndex.toFixed()}).${extension}`;
                            docIndex++;
                        }
                    }
                }
                else if (attachments[index].documentType !== curType.value) {
                    let fileNameParts = document.title.split('.');
                    if (fileNameParts.length > 0) {
                        let extension = fileNameParts[fileNameParts.length - 1].toLowerCase();
                        document.title = curType.title + '.' + extension;
                        let docIndex = 2;
                        while (attachments.find(a => a.title === document.title)) {
                            document.title = `${curType.title} (${docIndex.toFixed()}).${extension}`;
                            docIndex++;
                        }
                    }
                }
                let typeWasChanged = attachments[index].documentType !== curType.value;
                let typeBeforeChange = attachments[index].documentType;
                attachments[index] = document;
                if (typeWasChanged) {
                    let removeIndex = attachments.findIndex(a => a.documentType === curType.value && (a.state === attachmentStatuses.NotAdded || a.state === attachmentStatuses.Missing));
                    if (removeIndex >= 0) {
                        attachments.splice(removeIndex, 1);
                    }
                    if (attachments.findIndex(a => a.documentType === typeBeforeChange) < 0) {
                        attachments.push({
                            id: getNewAttachmentId(attachments),
                            state: attachmentStatuses.NotAdded,
                            documentType: typeBeforeChange
                        });
                    }
                }
            }
        }
        this.setState({
            attachments: attachments
        });
        if (this.props.changedCallback)
            this.props.changedCallback(attachments);
    }
    async downloadFiles(ids) {
        if (this.state.attachments && ids && ids.length > 0) {
            for (let i = 0; i < ids.length; i++) {
                let current = this.state.attachments.find(it => it.id === ids[i]);
                if (current) {
                    if (current.content?.content) {
                        let anchor = document.createElement("a");
                        anchor.href = `data:${current.content.mimeType};base64,` + current.content?.content;
                        anchor.download = current.title;
                        anchor.click();
                    }
                    else if (current.file) {
                        let objectUrl = window.URL.createObjectURL(current.file);
                        let anchor = document.createElement("a");
                        anchor.href = objectUrl;
                        anchor.download = current.file.name;
                        anchor.click();
                        window.URL.revokeObjectURL(objectUrl);
                    }
                    else if (current.nodeRef) {
                        downloadFile(current.nodeRef);
                    }
                }
            }
        }
    }
    async loadFilePreview(id) {
        var finded = this.state.attachments.filter(a => a.id === id);
        if (finded.length <= 0)
            return;
        var current = finded[0];
        const isImage = isImageFile(current.title);
        if (!current.title.toLowerCase().endsWith('.pdf') && !isImage) {
            this.downloadFiles([id]);
            return;
        }
        const currentObject = this;
        let data;
        if (current?.content?.content) {
            data = `data:${current.content.mimeType};base64,` + current?.content?.content;
        }
        else if (current.file) {
            data = (await getBase64(current.file, true)).content;
        }
        else if (current?.nodeRef) {
            if (isImage) {
                return require('../ModalDialogsTemplates').viewImageDialog(current?.nodeRef);
            }
            else {
                return require('../ModalDialogsTemplates').viewPdfDialog(current?.nodeRef);
            }
        }

        const src = data;
        if (isImage) {
            return require('../ModalDialogsTemplates').viewImage(src);
        }
        else {
            showModalDialog('modalDialog', i18next.t("viewingDocument"), "",
                [<div className="filter-block-header">
                    <ul className="filter-header-buttons one-icons">
                        <li>
                            <button type="button" className="btn no-bg-btn" onClick={() => currentObject.actionHandlerCallback(actionTypes.download, [id])}>
                                <div>
                                    <Svg src="/img/icn-download.svg" />
                                </div>
                                <span>{i18next.t("download")}</span>
                            </button>
                        </li>
                    </ul>
                </div>,
                <PdfViewer src={src} />]
                , "feedPopup max-size with-header-btns");
        }
    }
    async actionHandlerCallback(type, ids) {
        let { attachments } = this.state;
        let currentObject = this;
        const { changedCallback } = this.props;
        const { typesOfDocumens } = this.state;
        // eslint-disable-next-line default-case
        switch (type) {
            case actionTypes.remove:
                {
                    let closeDialog = function () {
                        hideModalDialog('modalDialog');
                    }
                    let confirmDialog = function () {
                        closeDialog();
                        currentObject.deleteAttachments(ids);
                    }
                    showModalDialog('modalDialog', i18next.t("removing"), "", <div className="info-message">{i18next.t("deleteFilesMessage")}</div>, "feedPopup", true, [{ title: i18next.t("yes"), clickHandler: confirmDialog, class: "btn-primary" }, { title: i18next.t("no"), clickHandler: closeDialog, class: "btn-secondary" }]);
                    break;
                }
            case actionTypes.preview:
                this.loadFilePreview(ids[0]);
                break;
            case actionTypes.download:
                this.downloadFiles(ids);
                break;
            case actionTypes.loadSigns:
                for (var i = 0; i < ids.length; i++)
                    downloadFile(ids[i], "", "", true);
                break;
            case actionTypes.add:
            case actionTypes.edit:
                {
                    let finded = this.state.attachments.find(a => a.id === ids[0]);
                    showModalDialog('modalDialog', i18next.t("editDocument"), "", <AttachmentForm {...finded} typesOfDocumens={typesOfDocumens} handleAddDocument={this.handleAddAttachment} onCloseHandler={() => { hideModalDialog('modalDialog'); }} />, "feedPopup middle-form");
                    break;
                }
            case actionTypes.notAdd:
                if (ids) {
                    let handleChangeComment = function (comment) {
                        for (let i = 0; i < ids.length; ++i) {
                            let item = attachments.find((item) => item.id === ids[i]);
                            item.comment = comment.content;
                            item.state = attachmentStatuses.Missing;
                        }
                        currentObject.setState({ attachments: attachments });
                        hideModalDialog('modalDialog')
                        if (changedCallback)
                            changedCallback(attachments);
                    }
                    showModalDialog('modalDialog', i18next.t("addComment"), "", <CommentForm handleChangeComment={handleChangeComment} onCloseHandler={() => { hideModalDialog('modalDialog'); }} />, "feedPopup middle-form");
                }
                break;
        }
        if (changedCallback)
            changedCallback(attachments);
    }
    onColumnFilter(colName, filterValues) {
        console.log(`Changed value of filter "${colName}": ${filterValues}`)
        const { filtersValues, columns } = this.state;
        filtersValues[colName] = filterValues;
        columns.find((item) => item.name === colName).filteredValues = filterValues;
        this.setState({
            filtersValues: filtersValues
        });
        globalEventDispatcher.dispatch(dispatcherActionTypes.onUnselectTableAllRows);
    }
    handlerCheckRowVisibility(row) {
        const { filtersValues, columns } = this.state;
        for (let key in filtersValues) {
            if (filtersValues[key].length > 0 && row.columns[key]) {
                let curEnum = columns.find((item) => item.name === key).enums.find((item) => item.title === row.columns[key]);
                if (!filtersValues[key].find((item) => item === curEnum.value)) return false;
            }
        }
        return true;
    }
    onSearchClear() {
        const { columns } = this.state;
        for (let i = 0; i < columns?.length; ++i) {
            columns[i].filteredValues = [];
        }
        this.setState({
            filtersValues: []
        });
    }
    render() {
        const { edite } = this.props;
        const { statuses, attachments, typesOfDocumens, columns, filtersValues } = this.state;
        let rows = [];
        const { actions } = settings.attachmentsTable;
        columns.find((item) => item.name === "DocumentType").enums = typesOfDocumens.map((value) => ({ title: value?.title, value: value?.value }));
        columns.find((item) => item.name === "State").enums = statuses.map((value) => ({ title: value?.label, value: value?.value }));
        if (attachments) {
            for (let i = 0; i < attachments.length; ++i) {
                let currActions = [];
                currActions.push(...actions.filter(item =>
                    (
                        edite &&
                        (
                            (item.type === actionTypes.edit && attachments[i].state !== attachmentStatuses.NotAdded) ||
                            (item.type === actionTypes.remove && attachments[i].state !== attachmentStatuses.NotAdded && attachments[i].state !== attachmentStatuses.Missing) ||
                            (
                                (attachments[i].state === attachmentStatuses.Missing || attachments[i].state === attachmentStatuses.NotAdded) &&
                                item.type === actionTypes.add
                            ) ||
                            (item.type === actionTypes.notAdd && attachments[i].state === attachmentStatuses.NotAdded)
                        )
                    ) ||
                    (
                        !edite &&
                        item.type === actionTypes.loadSigns &&
                        attachments[i].state === attachmentStatuses.Signed
                    ) ||
                    (
                        (attachments[i].state === attachmentStatuses.New || attachments[i].state === attachmentStatuses.Signed) &&
                        (
                            (item.type === actionTypes.preview && attachments[i].title?.endsWith('.pdf')) ||
                            (item.type === actionTypes.preview && isImageFile(attachments[i].title)) ||
                            item.type === actionTypes.download
                        )
                    )));
                let created = attachments[i]?.created ? new Date(attachments[i]?.created) : attachments[i]?.created;
                let curType = typesOfDocumens.find((item) => {
                    return item.value === attachments[i]?.documentType;
                });
                if (curType) {
                    rows.push({
                        actions: currActions,
                        columns: {
                            Id: attachments[i]?.id,
                            NodeRef: attachments[i]?.nodeRef,
                            Title: attachments[i]?.title,
                            DocumentType: getEnumsTitle(columns, "DocumentType", attachments[i]?.documentType),
                            Number: attachments[i]?.documentNumber,
                            DocumentDate: attachments[i]?.documentDate ? (new Date(attachments[i]?.documentDate)).toLocaleDateString("uk-UA") : "",
                            Comment: attachments[i]?.comment,
                            State: getEnumsTitle(columns, "State", attachments[i]?.state),
                            Created: created ? `${created.toLocaleDateString("uk-UA")} ${created.toLocaleTimeString("uk-UA").substring(0, 5)}` : "",
                            CreatorFullName: attachments[i]?.creatorFullName,
                            Indicator: this.props.getAttachmentIndicatorHandler ? this.props.getAttachmentIndicatorHandler(attachments[i]) : ""
                        }
                    });
                    rows = rows.filter((item) => this.handlerCheckRowVisibility(item));
                }
            }
        }
        return (
            <>
                <TableFilterBlock hideActions={true} filterValues={filtersValues} columnsSettings={{ columns: columns }} items={rows} onSearchClear={this.onSearchClear} />
                <Table name={settings.attachmentsTable.name} onColumnFilter={this.onColumnFilter} allowDoubleClickAction={true} actionHandlerCallback={this.actionHandlerCallback} columns={columns} items={rows} sortBy="Name" isDesk={false} />
            </>
        );
    }
}
export function getNewAttachmentId(attachments) {
    let id = 1;
    while (attachments.findIndex(a => a.id === id.toString()) >= 0) {
        id++;
    }
    return id.toString();
}